import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  updateRangeValue(event) {
    const parent = event.target.parentElement;
    const range_value = parent.querySelector(".range_value");
    if (range_value != null) {
      range_value.textContent = `${event.target.value} %`;
    }
  }
}
